<template
  @mousemove.prevent="mouseMove">
  <router-view></router-view>
</template>

<script>
  import {mapActions, mapState} from 'vuex';
  import router from './routes';

  export default {
    name: 'app',
    data () {
      return {
        idleTime: 0,
        timer: null
      }
    },
    computed: {
      ...mapState('auth', ['name', 'home', 'menus', 'roleId']),
      ...mapState('config', ['config']),
    },
    methods:{
      ...mapActions('auth', {
        logout: 'logout',
      }),
      mouseMove(event) {
        this.idleTime = 0;
      },
      fetchEventsList: function() {
        if (!(['', '5'].includes(this.roleId))) {
          var interval = 60;
          if (this.config != null) {
            var num = parseInt(this.config.idleInterval)
            if (num > 0) {
              interval = num;
            }
          }
              
          this.idleTime++;
          if (this.idleTime > interval) {
            this.$alert(this.config.idleMessage, '請注意', {
                confirmButtonText: this.$t('Confirm_txt'),
                callback: action => {
              }
            });
            this.logout();     
            router.go('/');        
          }
        }
      }
    },
    mounted () {
      this.timer = setInterval(this.fetchEventsList, 60000)
    },
    beforeDestroy() {
      if (this.timer != null) {    
        clearInterval(this.timer)  
      }
    }
  }
</script>